import React,{useState, useEffect} from "react"
import { Link,useNavigate,useParams } from "react-router-dom";
import  "../../../css/style-new.css";
import  "../../../css/developer1.css";
// import "../../css/bootstrap.min.css";
import "../../../css/font.css";
import axios from "axios";
import { schoolFacultyurl } from '../../../apis/urls'
import { schoolsurl } from '../../../apis/urls'
import { facultyposlists } from '../../../apis/urls'
import { degreeurl,mailsend } from '../../../apis/urls'
import moment from "moment";
import { decode } from "html-entities";

const ViewFaculty = () => {

    useEffect(() => {
        FacListing();
    },[]
    ); 

    
	let navigate = useNavigate();

    const { id, facid} = useParams();
    const username = localStorage.getItem('username')


    const[ result,setResult ] = useState('');
    const[ pos,setPos ] = useState([]);
    const[ facuid, setFacid] = useState('');
    const[ deg,setDeg ] = useState(''); 

    

    const Listing = () => {

		

        let token = "Bearer "+localStorage.getItem('token');
        
        const instance = axios.create({

            baseURL: schoolFacultyurl+'/'+id,

            timeout: 1000000,

            headers: {'authorization': token}

          });
          
          instance.get('').then((response) =>{
            
            setResult(response.data.data);
            //console.log(response.data)
           
          }).catch((error) =>{
            
            console.log('error',error.message)
            

          });
    }


    

    const FacListing = () => {

        let token = "Bearer "+localStorage.getItem('token');
        console.log(token)

        const instance = axios.create({
            baseURL: schoolFacultyurl+'/'+id+'/'+facid,
            timeout: 1000000,
            headers: {'authorization': token}
        });

        instance.get('').then(res => {
             console.log(res.data.data)
            setResult(res.data.data);
            Position(res.data.data.position_id);
            Degree(res.data.data.degree_id);
            setFacid(res.data.data.degree_id)
            console.log(facid)

        });

    }

    const Position = (pid)=>{
        let token = "Bearer "+localStorage.getItem('token');
        //console.log(token)

        const instance = axios.create({
            baseURL: facultyposlists+'/'+pid,
            timeout: 1000000,
            headers: {'authorization': token}
        });

        instance.get('').then(res => {
            
            //console.log('position',res.data.data)
            setPos(res?.data?.data?.name);
          });

    }


    const Degree = (did)=>{
        let token = "Bearer "+localStorage.getItem('token');
        //console.log(token)

        const instance = axios.create({
            baseURL: degreeurl+'/'+did,
            timeout: 1000000,
            headers: {'authorization': token}
        });

        instance.get('').then(res => {
            
            //console.log('degree',res.data.data)
            setDeg(res?.data?.data?.name);
          });

    }

    const Deletefaculty = (fid) => {

        let r = window.confirm("Are you sure you want to delete this Faculty?");

        if(r == true){
            
            let token = "Bearer "+localStorage.getItem('token');
        
        
            const instance = axios.create({

                baseURL: schoolFacultyurl+'/'+id+'/'+fid,

                timeout: 1000000,

                headers: {'authorization': token}

            });
            
            instance.delete('').then((response) =>{
                
                navigate("/school_list/faculty/"+id)
              // END MAIL SENDING
            
            }).catch((error) =>{
                
                console.log('error',error.message)

            
                

            });
        }
    }




    return(
        <div>
            <aside class="right-side areas">    
                <div class="content-area dash-contentss">
                   
                    <div class="page-title-wrpr">
                        <div class="page-title-left-column">
                            <i class="icon-library1"></i>
                            <h2 class="page-title">Admin/Staff</h2>
                        </div>

                        <div class="page-rightside-action-column"></div>
                    </div>

                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                            <li className="breadcrumb-item"><Link to={"/school_list/faculty/"+id}>Admin/Staff</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">Admin/Staff View({decode(result.first_name)})</li>
                        </ol>
                    </nav>

                    <div className="tab-content">

                        <div id="generalinfo" class="container tab-pane active"><br/>
                            <div class="row tab-section">
                                <div class="col-md-4">
                                    <label>First Name</label>
                                    <div>{decode(result.first_name)}</div>
                                </div>
                                <div class="col-md-4">
                                    <label>Last Name</label>
                                    <div>{decode(result.last_name)}<br/>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <label>Appointed Date</label>
                                    <div>{result.appointed_date}<br/>
                                    </div>
                                </div>
                            
                                
                            </div>

                            <div class="row tab-section">
                                <div class="col-md-4">
                                    <label>Email </label>
                                    <div style={{cursor: 'pointer'}} onClick={() => window.location = 'mailto:'+result.email}>{result.email}</div>
                                </div>
                                <div class="col-md-4">
                                    <label>School Phone</label>
                                    <div>{result.phone}<br/>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <label>Cell Phone</label>
                                    <div>{result.cell_phone}<br/>
                                    </div>
                                </div>
                                
                            </div>

                            <div class="row tab-section">
                                <div class="col-md-4">
                                    <label>Date Last Updated</label>
                                    <div>{moment(result.updatedAt).format('LL')}</div>
                                </div>
                                <div class="col-md-4">
                                    <label>Title/Position</label>
                                    {result.faculty_multiple_positions?.map((items,index)=>{
                                        return(<div>{decode(items.faculty_position.name)}</div>)
                                    })
                                    }
                                

                                </div>
                                <div class="col-md-4">
                                    {/* <label>Degree</label>
                                    {
                                        deg?
                                        ( <div>{deg}<br/></div>)
                                        :null
                                    } */}
                                    
                                    
                                </div>
                                <div class="col-md-4">
                                   
                                </div>

                                
                            </div>
                            <div className="list-action-wrpr showicons roundicons-text">
									<div className="list-action-wrpr">
                                        <Link to={"/edit_faculty/"+id+"/"+facid} data-toggle="tooltip" title="Edit"><i class="edit icon-pencil3"></i><span>Update</span></Link>
                                        <button onClick={() =>  { Deletefaculty(facid) } } style={{background:'#fff'}} data-toggle="tooltip" title="Delete" ><a><i class="delete icon-close1"></i><span>Delete</span></a></button>
                                    </div>
                                </div>
                                
                           
                        </div> 

                            

                    </div>
                    


                </div>
            </aside>
        </div>
    )
}

export default ViewFaculty;
